import * as actions from '../../store/actions'
import {store} from '../../store'


export const openTabsOnCompletion = () => {

    let state = store.getState();

    const tabsToOpenOnCompletion = state.session.vars.tabsToOpenOnCompletion || [];

    if (!Array.isArray(tabsToOpenOnCompletion)) return;

    tabsToOpenOnCompletion.forEach((d) => {
        window.open(d.url, d.tabName || '_blank')
    })

    store.dispatch(actions.session.setVar({tabsToOpenOnCompletion: null}))
}


export const getAndResetLoginPath = (defaultPath) => {
    let state = store.getState();
    let loginPath = state.session.vars.onLoginPath;
    if (loginPath) {
        // deep clone
        loginPath = `${loginPath}`;
        // reset
        store.dispatch(actions.session.setVar({onLoginPath: null}))
    } else {
        loginPath = defaultPath || '/my-projects';
    }
    return loginPath;
}